import secureApi from "../services/secureApi";

export const getProfitSummary = async () => {
  const response = await secureApi.get("/admin/dashboard/profitSummary");
  return response.data;
};

export const getTaxSummary = async () => {
  const response = await secureApi.get("/admin/dashboard/taxSummary");
  return response.data;
};

export const getPaymentSummary = async () => {
  const response = await secureApi.get("/admin/dashboard/paymentSummary");
  return response.data;
};

export const getCourierSummary = async () => {
  const response = await secureApi.get("/admin/dashboard/courierSummary");
  return response.data;
};
